import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { provideI18Next } from 'angular-i18next';
import { I18N_PROVIDERS } from './i18next';

import { SharedModule } from './shared/shared.module';
import { LayoutModule } from '@angular/cdk/layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { UiModule } from '@fullyops/legacy/ui';
import { DataModule, AuthEndpoint } from '@fullyops/legacy/data';
import { LoginComponent } from '@fullyops/legacy/pages/login/login.component';
import { ReactiveFormsModule } from '@angular/forms';

import { NotifyInterceptor } from './core/interceptors/notify.interceptor';
import { QuotaExceededInterceptor } from './core/interceptors/quota-exceeded.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CanDeactivateGuard } from './core/guards/can-deactivate.guard';
import { ResetPasswordComponent } from '@fullyops/legacy/pages/reset-password/reset-password.component';
import { ForgotPasswordComponent } from '@fullyops/legacy/pages/forgot-password/forgot-password.component';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { DownloadsComponent } from '@fullyops/legacy/pages/downloads/downloads.component';
import { TokenExpiredComponent } from '@fullyops/legacy/pages/token-expired/token-expired.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FeaturesModule } from '@fullyops/features/features.module';
import { GlobalErrorHandler } from '@fullyops/core/errors/global-error-handler';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { registerLocaleData } from '@angular/common';
import { LocaleService } from '@fullyops/shared/services/locale/locale.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

LocaleService.angularLocales.forEach((locale) => registerLocaleData(locale));

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule, // Main routes for application
    BrowserAnimationsModule,
    // CoreModule,           // Singleton objects (services, components that are loaded only once, etc.)
    SharedModule,
    LayoutModule, // Shared (multi-instance) objects
    UiModule,
    FeaturesModule,
    DataModule,
    ReactiveFormsModule,
    NgxGoogleAnalyticsModule.forRoot('G-5X6X2GQDB5'),
    NgxGoogleAnalyticsRouterModule,
    MatMomentDateModule,
    InfiniteScrollModule,
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    DownloadsComponent,
    TokenExpiredComponent,
  ],
  providers: [
    I18N_PROVIDERS,
    AuthEndpoint,
    CanDeactivateGuard,
    provideCharts(withDefaultRegisterables()),
    provideI18Next(),
    { provide: HTTP_INTERCEPTORS, useClass: NotifyInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: QuotaExceededInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'always' },
    },
    provideHotToastConfig({
      stacking: 'depth',
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
